module.exports = ".overlay-container {\n  max-width: 50%;\n  padding-right: 25px;\n  padding-bottom: 20px;\n  float: left; }\n"